<template>
  <div class="">
    <section-title
      content="Información de Lugar(es) de Servicio"
      :has-line="true"
    />
    <div class="bg-secondary-3 rounded p-4 px-2">
      <div>
        <div v-if="!editing" class="panel-row-without-selector mb-4 py-1">
          <div class="col-md-12 col-sm-12 text-center mt-3">
            <action-button
              class="w-50 py-2 btn-editing"
              i="fas fa-file-plus pr-4 text-green"
              text="Presione aquí para añadir Lugar de Servicio"
              @click.native.prevent="onAddFirttLocationService"
            />
          </div>
        </div>
        <div v-else>
          <validation-observer
            :ref="'locationServiceForm'"
            v-slot="{}"
            tag="form"
          >
            <div v-if="specialistLicenseDisciplines.length > 0" class="row">
              <div class="col-md-12 text-gray mb-2">
                Seleccione la(s) Disciplina(s) de Licencia(s) a las que desea
                añadir Lugar(es) de Servicio(s)
              </div>
              <div class="col-md-12">
                <div
                  class="
                    col-12
                    overflow-auto
                    max-height-100
                    border
                    rounded
                    bg-white
                    p-3
                  "
                >
                  <div
                    v-for="licenseDisciplines in specialistLicenseDisciplines"
                    :key="licenseDisciplines.specialistLicenseId"
                    class="mb-3"
                  >
                    <div class="license-label mb-2">
                      {{ licenseDisciplines.licenseSpecialtyName }}
                    </div>
                    <div class="mt-1 disciplines-container">
                      <div
                        v-for="licenseDiscipline in licenseDisciplines.licenseDiscipline"
                        :key="licenseDiscipline.discipline.id"
                      >
                        <check-box
                          v-model="licenseDiscipline.discipline.selected"
                          class="discipline-checkbox"
                          :text="licenseDiscipline.discipline.name"
                          @input="
                            onCheckDiscipline($event, licenseDiscipline, true)
                          "
                        />
                        <div
                          v-if="licenseDiscipline.subDisciplines.length > 0"
                          class="ml-4"
                        >
                          <div
                            v-for="subDiscipline in licenseDiscipline.subDisciplines"
                            :key="subDiscipline.id"
                          >
                            <check-box
                              v-model="subDiscipline.selected"
                              class="discipline-checkbox"
                              :text="subDiscipline.name"
                              @input="
                                onCheckDiscipline(
                                  undefined,
                                  licenseDiscipline,
                                  false
                                )
                              "
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <error
                  v-if="!hasValidDiscipline"
                  class="col-12 mx-3 mb-2"
                  :message="
                    'Favor seleccionar la(s) Disciplina(s) de Licencia(s) a la(s) que desea añadir Lugar(es) de Servicio(s).'
                  "
                  variant="no-border"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label class="data-title mb-0">Tipo de Lugar:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="specialistLocationType"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.locationTypeId"
                    :clearable="false"
                    custom-error-msg="El tipo de lugar es requerido."
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="locationTypes"
                    @input="onChangeLocationType"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <label class="data-title mb-0">Municipio:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="specialistMunicipality"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.municipalityId"
                    :clearable="false"
                    custom-error-msg="El municipio es requerido."
                    :disabled="!model.locationTypeId"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="municipalities"
                    @input="onChangeMunicipality"
                  />
                </validation-provider>
              </div>
              <div class="col-md-4">
                <label class="data-title mb-0">Lugar de Servicio:</label>
                <validation-provider
                  v-slot="{ errors }"
                  name="specialistLocationService"
                  rules="required"
                >
                  <custom-drop-down
                    v-model="model.locationServiceId"
                    :clearable="false"
                    custom-error-msg="El lugar de servicio es requerido."
                    :disabled="!model.municipalityId"
                    :error="errors[0]"
                    fieldkey="id"
                    fieldname="name"
                    :options="locationServices"
                  />
                </validation-provider>
              </div>
            </div>
            <div class="row">
              <div class="col-12 mt-3 mr-3">
                <div class="d-flex flex-row-reverse bd-highlight w-100 actions">
                  <div class="bd-highlight ml-2">
                    <action-button
                      i="fas fa-file-medical fa-lg"
                      text="Añadir"
                      variant="success"
                      @click="onSubmit"
                    />
                  </div>
                  <div class="mx-0 bd-highlight">
                    <action-button
                      id="modal-btn-cancelar"
                      i="fas fa-times-circle"
                      text="Cancelar"
                      variant="outline-danger"
                      @click="onCancel"
                    />
                  </div>
                </div>
              </div>
            </div>
          </validation-observer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import CheckBox from 'CheckBox';
import CustomDropDown from 'custom-drop-down';
import Error from 'custom-error';
import SectionTitle from 'SectionTitle';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import { ValidationProvider } from 'vee-validate';
import { getMunicipalitiesByProvider as _getMunicipalitiesByProvider } from '@/services/common/location.api.js';
import { getLocationTypes as _getLocationTypes } from '@/services/common/code.api.js';
import { getlocationServices as _getlocationServices } from '@/services/provider/location-service.api.js';
import {
  getAllDisciplinesBySpecialtyType as _getAllDisciplinesBySpecialtyType,
  getSpecialistLicenseDisciplines as _getSpecialistLicenseDisciplines,
} from '@/services/provider/specialist.api.js';
import disciplineTypes from '@/utils/constants/disciplineTypes.js';
import CodeLocationTypes from '@/utils/constants/codeLocationTypes';

export default {
  name: 'SpecialistLocationServiceInfo',
  components: {
    ActionButton,
    ValidationProvider,
    CustomDropDown,
    CheckBox,
    Error,
    SectionTitle,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    showLocationServiceForm: {
      type: Boolean,
      default: () => false,
    },
    companyId: {
      type: Number,
      default: () => 0,
    },
    specialtyTypeId: {
      type: Array,
      default: () => [],
    },
    specialistId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      model: {},
      editing: false,
      municipalities: [],
      locationServices: [],
      specialistLicenseDisciplines: [],
      locationTypes: [],
      hasValidDiscipline: true,
    };
  },
  computed: {
    headerConfig() {
      return {
        icon: 'fas fa-map-marker-alt',
        title: 'Información de Lugar(es) de Servicio',
      };
    },
    excludedLocationTypes() {
      return [CodeLocationTypes.CAAT, CodeLocationTypes.CSEE];
    },
  },
  mounted() {
    this.fetchDisciplines();
  },
  methods: {
    showForm() {
      this.editing = true;
    },
    async fetchMunicipalities() {
      const { data } = await _getMunicipalitiesByProvider(
        this.currentAcademicYearId,
        this.companyId,
        this.model.locationTypeId.id
      );
      this.municipalities = data;
    },
    async fetchLocationTypes() {
      const { data } = await _getLocationTypes(this.excludedLocationTypes);
      this.locationTypes = data;
    },
    async fetchLocationServices() {
      const payload = {
        academicYear: this.currentAcademicYearId,
        provider: this.companyId,
        locationType: this.model.locationTypeId.id,
        municipality: this.model.municipalityId.id,
      };
      const { data } = await _getlocationServices(payload);
      this.locationServices = data;
    },
    async onChangeLocationType(value) {
      this.model.locationTypeId = value;
      this.model.municipalityId = null;
      this.model.locationServiceId = null;
      this.fetchMunicipalities();
    },
    async onChangeMunicipality(value) {
      this.model.municipalityId = value;
      this.model.locationServiceId = null;
      this.fetchLocationServices();
    },
    onCheckDiscipline(chechked, discipline, isDiscipline) {
      if (
        discipline?.discipline?.id ===
          disciplineTypes.TerapiaEntrenamientoAuditivo &&
        isDiscipline
      ) {
        discipline.discipline.selected = chechked;
        if (!chechked) {
          discipline.subDisciplines.forEach((subDiscipline) => {
            subDiscipline.selected = false;
          });
        }
      } else {
        if (discipline?.subDisciplines.some((x) => x.selected))
          discipline.discipline.selected = true;
      }

      this.hasValidDiscipline = true;
      const disciplines = this.specialistLicenseDisciplines.map((x) => {
        return {
          specialistLicenseId: x.specialistLicenseId,
          licenseSpecialtyName: x.licenseSpecialtyName,
          disciplines: x.licenseDiscipline
            .filter((y) => y.discipline.selected)
            .map((d) => {
              const { discipline } = d;
              return {
                disciplineId: discipline.id,
                disciplineName: discipline.name,
                subDisciplines: d.subDisciplines
                  .filter((sub) => sub.selected)
                  .map((sub) => {
                    return {
                      subDisciplineId: sub.id,
                      subDisciplineName: sub.name,
                    };
                  }),
              };
            }),
        };
      });

      this.model.disciplines = disciplines.filter(
        (x) => x.disciplines.length > 0
      );
    },
    async onSubmit() {
      this.hasValidDiscipline = this.specialistLicenseDisciplines.some((x) =>
        x.licenseDiscipline.some((e) => e.discipline.selected)
      );

      const AuditoryTrainingTherapy = this.model?.disciplines
        ?.map((x) => x.disciplines)
        .flat()
        .find(
          (x) => x.disciplineId === disciplineTypes.TerapiaEntrenamientoAuditivo
        );

      if (AuditoryTrainingTherapy) {
        if (AuditoryTrainingTherapy.subDisciplines.length === 0) {
          this.ShowToast(
            'Alerta',
            'Favor seleccionar al menos una subdisciplina para la terapia de Entrenamiento Auditivo.',
            'error'
          );
          return;
        }
      }

      const isFormValid =
        (await this.$refs['locationServiceForm'].validate()) &&
        this.hasValidDiscipline;

      if (!isFormValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }

      this.editing = false;
      this.$emit('on-add-location-service', this.model);
    },
    onCancel() {
      this.editing = false;
      this.model = {
        locationTypeId: null,
        municipalityId: null,
      };
      this.$emit('cancel');
    },
    async onAddFirttLocationService() {
      this.editing = true;
      const { data } = await _getSpecialistLicenseDisciplines(
        this.specialistId
      );
      if (data.length > 0) this.specialistLicenseDisciplines = data;
    },
    async fetchDisciplines(types) {
      if (!types) return;
      const { data } = await _getAllDisciplinesBySpecialtyType(types);
      if (data.length > 0) this.specialistLicenseDisciplines = data;
    },
  },
  watch: {
    editing: function(value) {
      if (value) {
        this.$emit('update:showLocationServiceForm', true);
        this.fetchLocationTypes();
        return;
      }
    },
    specialtyTypeId: function(value) {
      this.fetchDisciplines(value);
    },
    showLocationServiceForm: function(value) {
      if (!value) {
        this.editing = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

.btn-editing {
  border: 1px solid map-get($colors, 'gray-5');
}

.license-label {
  color: map-get($colors, 'gray-7');
  font-weight: bold;
}

.disciplines-container .discipline-checkbox {
  font-weight: normal;
  color: map-get($colors, 'gray-6');
}

::v-deep input[type='checkbox']:checked + label span {
  background-color: map-get($colors, 'green') !important;
}

::v-deep input[type='checkbox']:checked + label span em {
  filter: brightness(0) invert(1);
}

.license-disciplines-title {
  margin-left: 24px;
  padding: 7px 16px;
  font-weight: normal;
  color: map-get($colors, 'gray-6');
}

.max-height-100 {
  max-height: 300px !important;
}
</style>
